import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

import { useFinanceReceiverStore } from "@/modules/financeReceiver/store";

export default async function redirectToOnboardingIfRequired(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const financeReceiverStore = useFinanceReceiverStore();
  await financeReceiverStore.fetchFinanceReceiver();
  if (financeReceiverStore.isOnboarding) {
    return next({ name: "onboarding" });
  }
  next();
}
